import { Requester } from './Requester';
import { ILoanGroupRecord } from '../types';

export const GetOrganizationLoanGroups = async ({
    orgId
}: {
    orgId: string;
}): Promise<{ loanGroups: ILoanGroupRecord[] } | null> => {
    try {
        const response = await Requester<{ loanGroups: ILoanGroupRecord[] }>({
            // port: '8080',
            path: `organizations/${orgId}/loanGroups`,
            method: 'GET'
        });

        if ('loanGroups' in response && Array.isArray(response.loanGroups)) return response;
        return null;
    } catch (e) {
        console.error('Get org loan groups request failed');
        return Promise.reject(e);
    }
};
